export var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
];
var monthLabels = {
    "01": {
        en: "Jan",
        es: "Ene",
    },
    "02": {
        en: "Feb",
        es: "Feb",
    },
    "03": {
        en: "Mar",
        es: "Mar",
    },
    "04": {
        en: "Apr",
        es: "Abr",
    },
    "05": {
        en: "May",
        es: "May",
    },
    "06": {
        en: "Jun",
        es: "Jun",
    },
    "07": {
        en: "Jul",
        es: "Jul",
    },
    "08": {
        en: "Aug",
        es: "Ago",
    },
    "09": {
        en: "Sep",
        es: "Sep",
    },
    "10": {
        en: "Oct",
        es: "Oct",
    },
    "11": {
        en: "Nov",
        es: "Nov",
    },
    "12": {
        en: "Dec",
        es: "Dic",
    },
};
export default monthLabels;
